import { render, staticRenderFns } from "./AccountingBooksReceiptStandartList.vue?vue&type=template&id=e37bf252&"
import script from "./AccountingBooksReceiptStandartList.vue?vue&type=script&lang=js&"
export * from "./AccountingBooksReceiptStandartList.vue?vue&type=script&lang=js&"
import style0 from "./AccountingBooksReceiptStandartList.vue?vue&type=style&index=0&id=e37bf252&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports